import { connect } from "react-redux"
import { Session } from "@/redux/_session.types"
import Chip from "./chip"

interface StateProps {
  _session: Session
}

interface OwnProps {
  onBlur?: Function
  onChange?: Function
  min: number
  max: number
  step?: number
  value: number
  hideValue?: boolean
  isFullWidth?: boolean
  color?: string
}

type Props = StateProps & OwnProps

function Range(props: Props) {
  function blur(e: any) {
    props.onBlur?.(Number(e.target.value))
  }

  function change(e: any) {
    props.onChange?.(Number(e.target.value))
  }

  return (
    <div className="flex items-center gap-2">
      <input
        type="range"
        step={props.step}
        min={props.min}
        max={props.max}
        value={props.value}
        onBlur={blur}
        onChange={change}
        className={`range-custom ${props.color ? "range-colored" : ""}`}
        style={{
          width: props.isFullWidth ? "100%" : 300,
          ...(props.color ? ({ "--range-color": props.color } as React.CSSProperties) : {})
        }}
      />
      {!props.hideValue && <Chip>{props.value}</Chip>}
    </div>
  )
}

const mapStateToProps = (state) => ({
  _session: state._session
})

export default connect(mapStateToProps)(Range)
